import { render } from "./CaseStudy.vue?vue&type=template&id=0a0d9b26"
import script from "./CaseStudy.vue?vue&type=script&lang=js"
export * from "./CaseStudy.vue?vue&type=script&lang=js"

import "./CaseStudy.vue?vue&type=style&index=0&id=0a0d9b26&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__